import { Divider, ListItem, ListItemText } from '@mui/material';
import { toast } from '@side/pantry';
import { SideSupport } from 'src/components/SideSupport/SideSupport';
import { openUrlInNewTab } from '@/common/utils/url';
import { PackageLinkPopupMenu } from './PackageLinkPopupMenu';

export interface Props {
  label: string;
  link: string;
  shortUrlId: string;
  warning?: boolean;
}

export const PackageLink = ({ label, link, warning, shortUrlId }: Props) => {
  const onPackageDocumentsClick = () => {
    if (link) {
      openUrlInNewTab(link, { decoding: 'paths-only' });
    } else {
      toast(
        'error',
        <>
          Download failed. Try again or contact&nbsp;
          <SideSupport />
          &nbsp;for assistance.
        </>,
        { showCloseButton: true },
      );
    }
  };
  return (
    <ListItem
      disablePadding
      sx={{
        border: 1,
        borderColor: 'other.outlineBorder',
        marginBottom: 1,
      }}
    >
      <ListItemText
        primary={label}
        onClick={onPackageDocumentsClick}
        sx={{
          paddingLeft: 2,
          cursor: 'pointer',
          color: warning ? 'warning.dark' : 'primary.main',
        }}
      />
      <Divider orientation="vertical" flexItem />
      <PackageLinkPopupMenu link={link} label={label} shortUrlId={shortUrlId} />
    </ListItem>
  );
};
